import { render, staticRenderFns } from "./admitCardCountBySubject.vue?vue&type=template&id=0bd0e7d3&scoped=true&"
import script from "./admitCardCountBySubject.vue?vue&type=script&lang=js&"
export * from "./admitCardCountBySubject.vue?vue&type=script&lang=js&"
import style0 from "./admitCardCountBySubject.vue?vue&type=style&index=0&id=0bd0e7d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0e7d3",
  null
  
)

export default component.exports